import React from 'react';
import './upload-invoice-actions.scss';
import { Text, View } from '../../common';
import { SVGS } from '../../assets';
import { kebabCase } from 'lodash';

interface UploadInvoiceActionsProps {
  onUpload: (options?: any) => Promise<unknown>;
}
export const UploadInvoiceActions: React.FC<UploadInvoiceActionsProps> = ({
  onUpload,
}) => {
  const uploadInvoiceActions = [
    {
      title: 'Upload File',
      icon: SVGS.UploadFile,
      action: () => onUpload({ useDocumentAsync: true, type: '*' }),
    },
    {
      title: 'Take Photo',
      icon: SVGS.CameraIcon,
      action: () => onUpload({ type: 'camera' }),
    },
    {
      title: 'Choose From Photos',
      icon: SVGS.PhotosIcon,
      action: () => onUpload({ type: 'gallery' }),
    },
  ];

  return (
    <View className="upload-invoice-actions">
      <View className="upload-invoice-actions-container">
        {uploadInvoiceActions?.map((action, idx, actions) => (
          <>
            <View
              className="upload-invoice-actions-container-button"
              key={kebabCase(action?.title)}
              onPress={() => {
                action?.action();
              }}
            >
              <View className="upload-invoice-actions-container-button-icon">
                <img
                  src={action.icon}
                  alt={kebabCase(action.title)}
                  width={20}
                  height={20}
                />
              </View>
              <Text className="upload-invoice-actions-container-button-text font-semibold">
                {action?.title}
              </Text>
            </View>
            {idx < actions.length - 1 && (
              <View
                className="upload-invoice-actions-container-divider"
                key={idx}
              />
            )}
          </>
        ))}
      </View>
    </View>
  );
};
